import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';

const CLICK_EVENT = 'click';
const WRAPPER_SELECTORS = ['.p-venue-registeration-landing-multisite-with-venue', '.p-venue-registration-landing'];
const TRIGGER_SELECTOR = '.js-policies-locked-trigger';
const MODAL_SELECTOR = '#policies-locked-modal';

/**
 * Opens the "This section is currently locked" overlay modal when the
 * locked Policies spotlight-card is clicked, instead of opening the
 * policies form modal.
 */
class PoliciesLockedModal {
	constructor() {
		this._wrapper = WRAPPER_SELECTORS.map((selector) => SelectorEngine.findOne(selector)).find(Boolean);
		if (!this._wrapper) {
			return;
		}

		this.modal = SelectorEngine.findOne(MODAL_SELECTOR, this._wrapper);
		if (!this.modal) {
			return;
		}

		EventHandler.on(this._wrapper, CLICK_EVENT, TRIGGER_SELECTOR, (event) => {
			event.preventDefault();
			this.modal.isOpen = true;
		});
	}

	static boot() {
		const start = () => requestAnimationFrame(() => new PoliciesLockedModal());

		if (customElements.get('lta-overlay-modal')) {
			start();
		} else {
			customElements
				.whenDefined('lta-overlay-modal')
				.then(start)
				.catch(() => {});
		}
	}
}

PoliciesLockedModal.boot();

export default PoliciesLockedModal;
